// localStorage keys cleared on logout. 'portal_impersonation' lives here (not in
// sessionStorage) so it matches the cross-tab scope of the portal tokens and is
// cleared on logout/idle alongside them.
const PORTAL_LOGOUT_STORAGE_KEYS = ['formioToken', 'tokenExpiration', 'formioUser', 'portal_impersonation'] as const;

const PORTAL_SESSION_STORAGE_KEYS = ['selectedPatientGuid'] as const;

export function clearPortalLogoutStorage(storage: Storage): void {
  for (const key of PORTAL_LOGOUT_STORAGE_KEYS) {
    storage.removeItem(key);
  }
}

export function clearPortalSessionStorage(storage: Storage): void {
  for (const key of PORTAL_SESSION_STORAGE_KEYS) {
    storage.removeItem(key);
  }
}

/**
 * Clears every browser-storage key a portal session owns. Every forced-signout path must call this,
 * otherwise a Form.io credential or an impersonation marker outlives the session that created it.
 */
export function clearAllPortalStorage(doc: Document): void {
  clearPortalLogoutStorage(doc.defaultView?.localStorage ?? localStorage);
  clearPortalSessionStorage(doc.defaultView?.sessionStorage ?? globalThis.sessionStorage);
}
